'use client';

import { useEffect } from 'react';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';

interface ShippingInsuranceScriptProps {
  projectSettings: ProjectSettings;
}

const ShippingInsuranceScript: React.FC<ShippingInsuranceScriptProps> = ({ projectSettings }) => {
  useEffect(() => {
    if (projectSettings.isNarvarEnabled && projectSettings.narvarSDKScriptContent && projectSettings.narvarScriptId) {
      const existingScript = document?.getElementById(projectSettings?.narvarScriptId);
      if (!existingScript) {
        const scriptTag = document.createElement('script');
        scriptTag.id = projectSettings?.narvarScriptId;
        scriptTag.textContent = projectSettings.narvarSDKScriptContent;
        document.head.appendChild(scriptTag);
      }
    }
  }, [projectSettings]);
  return null;
};

export default ShippingInsuranceScript;
